import React from 'react';
import { Icon, IconSize } from '@bechtel/gds';
import { PriorityWeldIconStyled } from './styled';

export const PriorityWeldIcon = () => {
  return (
    <PriorityWeldIconStyled data-testid="weld-icon">
      <Icon icon="flame" size={IconSize.XSMALL} fillColor="white" />
    </PriorityWeldIconStyled>
  );
};
